import React from 'react';
import PropTypes from 'prop-types';

import OverrideButton from './override_button';
import { Row, Col } from 'react-bootstrap';

export default function SelectOption({ defaults, option, onUpdate, onRemove }) {
  const hasSelectedValue = defaults.hasOwnProperty(option.name);
  const selectedValue = defaults[option.name];

  return (
    <Row className="row-eq-height">
      <Col md={6} xs={8}>
        <div className="form-group grow mb-0">
          <div className="d-flex m-0 row">
            <div className="p-0 col-xs-3">
              <div className="control-label w-100 h-100">
                <label>{option.label}</label>
              </div>
            </div>
            <div className={`border col-xs-9 ${hasSelectedValue ? '' : 'd-flex align-items-center'}`}>
              {!hasSelectedValue && (
                <span className="text-muted">Buildout Default</span>
              )}
              {hasSelectedValue &&
                option.options.map(childOption => (
                  <div className="radio" key={childOption.name}>
                    <label>
                      <input
                        checked={selectedValue == childOption.name}
                        className="mr-2"
                        disabled={!hasSelectedValue}
                        name={option.name}
                        type="radio"
                        onChange={() => onUpdate({ [option.name]: childOption.name })}
                      /> {childOption.name}
                    </label>
                  </div>
                ))
              }

            </div>
          </div>
        </div>
      </Col>
      <Col md={6} xs={4}>
        <OverrideButton
          disabled={!hasSelectedValue}
          onRemove={() => onRemove([option.name])}
          onReset={() => onUpdate({ [option.name]: option.options[0].name })}
        />
      </Col>
    </Row>
  );
}

SelectOption.propTypes = {
  defaults: PropTypes.object,
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string
  }),
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
